import React from 'react';
import Referral from './Referral';

/**
 * Post-submit page focused on ITR referrals.
 */
export default function PostSubmitPlaceholder() {
  return <Referral postSubmitMode />;
}
